module.exports = __webpack_public_path__ + "img/carrito.93681ee3.png";